var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"homeBanner"}},[_c('router-link',{attrs:{"to":"/products"}},[_c('img',{staticClass:"w-100",attrs:{"src":require("@/assets/images/homeBanner.jpg"),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }